{
  "intro": "Файрвол фильтрует трафик серверов ещё до того, как он до них дойдёт. Сервер без файрвола принимает всё. Когда файрвол применён, проходит только то, что разрешают его правила, остальное отбрасывается. Файрволы бесплатны.",
  "create": "Создать файрвол",
  "empty": "Файрволов пока нет",
  "emptyLead": "Без файрвола любой порт, который открывает сервер, доступен из интернета. Создайте файрвол, который разрешает только нужное, например SSH и веб-порты, и примените его к серверам.",
  "name": "Название",
  "nameHint": "Что он защищает, например web-public.",
  "rules": "Правила",
  "rulesCount": "входящих: {{inbound}}, исходящих: {{outbound}}",
  "appliedTo": "Применён к",
  "appliedNothing": "Ни к чему",
  "appliedCount": "серверов: {{servers}}, селекторов: {{selectors}}",
  "createdOn": "Создан",
  "open": "Открыть",
  "delete": "Удалить",
  "inUseReason": "Применён к ресурсам; сначала уберите его со всех.",
  "back": "Все файрволы",
  "notFound": "Этого файрвола больше нет.",
  "newTitle": "Новый файрвол",
  "newIntro": "Задайте правила и выберите, к чему применить файрвол. Правила только разрешают: всё, что под них не подходит, после применения отбрасывается.",
  "stepName": "Название",
  "stepInbound": "Входящие правила",
  "stepInboundLead": "Трафик, который приходит на сервер. SSH и ping отовсюду уже заполнены; измените или удалите их при необходимости.",
  "stepOutbound": "Исходящие правила",
  "stepOutboundLead": "Трафик, который уходит с сервера. Без исходящих правил разрешён весь исходящий трафик; стоит добавить правило — и уйти сможет только разрешённое.",
  "stepApply": "К чему применить",
  "stepApplyLead": "Выберите серверы или примените по селектору меток: файрвол получат серверы с подходящими метками, в том числе созданные позже.",
  "stepLabels": "Метки",
  "summary": "Итог",
  "summaryInbound": "Входящие правила",
  "summaryOutbound": "Исходящие правила",
  "summaryOutboundAll": "разрешено всё",
  "summaryServers": "Серверы",
  "summarySelectors": "Селекторы меток",
  "summaryNotApplied": "Пока ни к чему не применён: без применения файрвол ни на что не влияет.",
  "submit": "Создать файрвол",
  "created": "Файрвол «{{name}}» создан",
  "fixErrors": "Некоторые правила заполнены не до конца. Проверьте выделенные поля.",
  "direction": {
    "in": "Входящее",
    "out": "Исходящее"
  },
  "protocol": "Протокол",
  "port": "Порт или диапазон",
  "portHint": "22 или 8000-8100",
  "portNone": "Без портов",
  "portInvalid": "Укажите порт (22) или диапазон (8000-8100), от 1 до 65535.",
  "sources": "Разрешённые источники",
  "destinations": "Разрешённые назначения",
  "ipsHint": "Адреса с префиксом через запятую: 203.0.113.0/24, 2001:db8::/32",
  "ipsInvalid": "Укажите адреса с префиксом через запятую, например 203.0.113.7/32.",
  "ipsRequired": "Укажите хотя бы один диапазон или выберите «отовсюду».",
  "anyIpv4": "Любой IPv4",
  "anyIpv6": "Любой IPv6",
  "description": "Описание",
  "descriptionHint": "Необязательно, например для чего порт.",
  "addRule": "Добавить правило",
  "removeRule": "Удалить правило",
  "noInbound": "Входящих правил нет: после применения файрвол не пропустит ничего.",
  "noOutbound": "Исходящих правил нет: весь исходящий трафик разрешён.",
  "servers": "Серверы",
  "noServersInProject": "В проекте пока нет серверов. Примените файрвол позже или по селектору меток.",
  "labelSelectors": "Селекторы меток",
  "labelSelectorsHint": "По одному на строку, например role=web или env in (prod,staging).",
  "tabs": {
    "rules": "Правила",
    "resources": "Ресурсы",
    "settings": "Настройки",
    "delete": "Удаление"
  },
  "rulesIntro": "Правила только разрешают трафик; когда файрвол применён, всё, что не подходит ни под одно правило, отбрасывается. Сохранение заменяет весь набор правил сразу.",
  "unsaved": "Есть несохранённые изменения правил.",
  "save": "Сохранить правила",
  "discard": "Отменить изменения",
  "saving": "Сохраняем правила",
  "leaveTitle": "Уйти без сохранения?",
  "leaveLead": "Если уйти со страницы сейчас, изменения правил пропадут.",
  "leave": "Уйти",
  "stay": "Остаться",
  "resourcesIntro": "К чему применён файрвол. Если на сервере несколько файрволов, действуют правила всех.",
  "applyServers": "Применить к серверам",
  "applyServersLead": "Файрвол сразу начнёт фильтровать трафик выбранных серверов.",
  "applySelector": "Применить по селектору меток",
  "applySelectorLead": "Файрвол получит каждый сервер с подходящими метками, в том числе созданный позже.",
  "selector": "Селектор меток",
  "selectorHint": "Например, role=web, env!=dev или tier in (a,b).",
  "selectorInvalid": "Укажите селектор меток, например role=web.",
  "noCandidates": "Этот файрвол уже есть на всех серверах проекта.",
  "apply": "Применить",
  "applying": "Применяем файрвол",
  "target": "Применён к",
  "targetServer": "Сервер",
  "targetKind": "Вид",
  "targetSelector": "Селектор меток",
  "matches": "Подходящие серверы",
  "matchesNone": "сейчас нет",
  "notApplied": "Ни к чему не применён",
  "notAppliedLead": "Пока файрвол не применён к серверам или селектору меток, он ни на что не влияет.",
  "remove": "Убрать",
  "removeTitle": "Убрать файрвол с {{name}}?",
  "removeConsequence": "Его правила перестанут там действовать: без другого файрвола сервер будет принимать весь трафик.",
  "removeSelectorConsequence": "Серверы, которые получили его только через этот селектор, перестанут им фильтроваться.",
  "removing": "Убираем файрвол",
  "settingsIntro": "Название и метки файрвола.",
  "saved": "Сохранено",
  "deleteIntro": "Удаление файрвола нельзя отменить. Удалить можно только файрвол, который ни к чему не применён.",
  "deleteTitle": "Удалить файрвол «{{name}}»?",
  "deleteRules": "Его правила удаляются вместе с ним.",
  "deleteNoEffect": "Он ни к чему не применён, поэтому серверы не изменятся.",
  "deleteBlocked": "Файрвол ещё применён. Сначала уберите его со всех ресурсов.",
  "removeAll": "Убрать со всех ресурсов",
  "removeAllTitle": "Убрать «{{name}}» со всех ресурсов?",
  "removeAllConsequence": "Защищённые им серверы будут принимать весь трафик, если на них нет другого файрвола.",
  "deleted": "Файрвол «{{name}}» удалён",
  "running": "Изменение выполняется…",
  "anyPort": "Любой порт",
  "anyPortInbound": "Открыты все порты {{protocol}} (1–65535): любая программа на сервере, которая слушает {{protocol}}, станет доступна с этих адресов, в том числе базы данных и панели управления. Если нужны лишь несколько портов, перечислите их отдельными правилами.",
  "anyPortOutbound": "Разрешены все порты {{protocol}} (1–65535) к этим адресам."
}
